import { Tag } from "@brg/api";

export const getUpdated = (prev: any, current: any, flag?: string) => {
    const isArray = (a: any) => Array.isArray(a);

    if (prev && current) {
        return (flag ? current : prev)?.map((i: any) => {
            //@ts-ignore
            if (i?.categoryId === current[0]?.categoryId) {
                const childs = i?.childrens.filter((c: any, index: number, self: any) =>
                    c?.tagId !== current[0]?.childrens?.[0]?.tagId && index === self.findIndex((el: any) => el?.tagId === c?.tagId))
                const preVal = {...i};

                if (current[0]?.childrens?.length >= 1) {
                    const newChild = current[0]?.childrens?.length > 1 ? current[0]?.childrens : {...current[0]?.childrens[0]};
                    //@ts-ignore
                    preVal.childrens = [];

                    if (!isArray(newChild) ) {
                        newChild['isChildrenVisible'] = flag ? false : true
                    }

                    const res = isArray(newChild) ? newChild : [{...newChild}];
                    const resIndex = i?.childrens.findIndex((c: any) => c?.tagId === current[0]?.childrens?.[0]?.tagId);
                    const newChildsBegin = childs.slice(0, resIndex);
                    const newChildsEnd = childs.slice(resIndex);

                    return {
                        ...preVal,
                        childrens: flag ? [...res]
                        : [
                                ...(resIndex === -1
                                    ? [...childs, ...res.filter(r => !childs.some((c: Tag) => c?.tagId === r?.tagId)) ]
                                    : [...newChildsBegin, ...res, ...newChildsEnd])
                        ]
                    }
                }
                else {
                    return {
                        ...preVal,
                        childrens: flag ? []
                        : [
                            ...childs
                        ]
                    };
                }
                
            }
            return i;
        })
    }
}

export const getSearched = (prev: any, current: any, loadType?: number) => {

    const res = prev.map((v: any) => {
        if ( v?.categoryId === current[0]?.categoryId) {

            if (loadType) {
                return {
                    ...v,
                    childrens: current[0]?.childrens?.map((i: any) => ({
                        ...i,
                        isChildrenVisible: false
                    }))
                }
            }
               const tag = v?.childrens.filter((i: any) => i?.tagId === current[0]?.childrens[0]?.tagId);

               if (tag.length) {
                const t = {...tag[0]};

                t['isChildrenVisible'] = !t.isChildrenVisible

        
                const childs = v?.childrens.filter((c: any) => c?.tagId !== current[0]?.childrens[0]?.tagId)
                const resIndex = v?.childrens.findIndex((c: any) => c?.tagId === current[0]?.childrens?.[0]?.tagId);
                const newChildsBegin = childs.slice(0, resIndex);
                const newChildsEnd = childs.slice(resIndex);
                const preVal = {...v};
                //@ts-ignore
                const { additionalTags } = {...current[0]?.childrens[0]};
                 //@ts-ignore
                preVal.childrens = [];
                t.additionalTags = [
                    ...additionalTags
                ]

                return {
                    ...preVal,
                    childrens: [
                        ...(resIndex === -1 ? [...childs, t] : [...newChildsBegin, t, ...newChildsEnd])
                    ]
                }
               }

        }
        return v;
    });

    return res
}import { Tag } from "@brg/api";

export const getUpdated = (prev: any, current: any, flag?: string) => {
    const isArray = (a: any) => Array.isArray(a);

    if (prev && current) {
        return (flag ? current : prev)?.map((i: any) => {
            //@ts-ignore
            if (i?.categoryId === current[0]?.categoryId) {
                const childs = i?.childrens.filter((c: any, index: number, self: any) =>
                    c?.tagId !== current[0]?.childrens?.[0]?.tagId && index === self.findIndex((el: any) => el?.tagId === c?.tagId))
                const preVal = {...i};

                if (current[0]?.childrens?.length >= 1) {
                    const newChild = current[0]?.childrens?.length > 1 ? current[0]?.childrens : {...current[0]?.childrens[0]};
                    //@ts-ignore
                    preVal.childrens = [];

                    if (!isArray(newChild) ) {
                        newChild['isChildrenVisible'] = flag ? false : true
                    }

                    const res = isArray(newChild) ? newChild : [{...newChild}];
                    const resIndex = i?.childrens.findIndex((c: any) => c?.tagId === current[0]?.childrens?.[0]?.tagId);
                    const newChildsBegin = childs.slice(0, resIndex);
                    const newChildsEnd = childs.slice(resIndex);

                    return {
                        ...preVal,
                        childrens: flag ? [...res]
                        : [
                                ...(resIndex === -1
                                    ? [...childs, ...res.filter(r => !childs.some((c: Tag) => c?.tagId === r?.tagId)) ]
                                    : [...newChildsBegin, ...res, ...newChildsEnd])
                        ]
                    }
                }
                else {
                    return {
                        ...preVal,
                        childrens: flag ? []
                        : [
                            ...childs
                        ]
                    };
                }
                
            }
            return i;
        })
    }
}

export const getSearched = (prev: any, current: any, loadType?: number) => {

    const res = prev.map((v: any) => {
        if ( v?.categoryId === current[0]?.categoryId) {

            if (loadType) {
                return {
                    ...v,
                    childrens: current[0]?.childrens?.map((i: any) => ({
                        ...i,
                        isChildrenVisible: false
                    }))
                }
            }
               const tag = v?.childrens.filter((i: any) => i?.tagId === current[0]?.childrens[0]?.tagId);

               if (tag.length) {
                const t = {...tag[0]};

                t['isChildrenVisible'] = !t.isChildrenVisible

        
                const childs = v?.childrens.filter((c: any) => c?.tagId !== current[0]?.childrens[0]?.tagId)
                const resIndex = v?.childrens.findIndex((c: any) => c?.tagId === current[0]?.childrens?.[0]?.tagId);
                const newChildsBegin = childs.slice(0, resIndex);
                const newChildsEnd = childs.slice(resIndex);
                const preVal = {...v};
                //@ts-ignore
                const { additionalTags } = {...current[0]?.childrens[0]};
                 //@ts-ignore
                preVal.childrens = [];
                t.additionalTags = [
                    ...additionalTags
                ]

                return {
                    ...preVal,
                    childrens: [
                        ...(resIndex === -1 ? [...childs, t] : [...newChildsBegin, t, ...newChildsEnd])
                    ]
                }
               }

        }
        return v;
    });

    return res
}